import { FC } from "react";
import { useTranslation } from "react-i18next";
import { GenericEntityPage } from "../../shared/GenericEntityPage";
import PartnersCard from "./PartnersCard";
import { partnersServiceFactory } from "../../../services/PartnersServiceImpl";
import { IPartners, PartnersFiltersValues } from "../../../domain/models/Partners";
import { partnersFiltersFields, partnersFiltersSchemaFactory } from "../../../validation-schemas/PartnersSchemas";
import PartnersEditor from "./PartnersEditor";

const partnersService = partnersServiceFactory();

const PartnersPage: FC = () => {
    const { t } = useTranslation();

    return (
        <GenericEntityPage<IPartners, PartnersFiltersValues>
            filtersFieldsMeta={partnersFiltersFields}
            filtersSchema={partnersFiltersSchemaFactory(t)}
            service={partnersService}
            renderItem={(item, onEdit, onDelete) => (
                <PartnersCard item={item} onEdit={onEdit} onDelete={onDelete} onClick={() => 1} />
            )}
            renderEditor={({ entity, onClose, onSave, translateFields }) => (
                <PartnersEditor entity={entity} onClose={onClose} onSave={onSave} translateFields={translateFields} />
            )}
        />
    );
};

export default PartnersPage;
